var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53902 22.5C16.5954 22.5 21.551 14.9956 21.551 8.49877C21.551 8.28765 21.551 8.07653 21.5414 7.8654C22.5018 7.17446 23.3373 6.30118 24 5.31275C23.1164 5.7062 22.1657 5.96531 21.1669 6.09006C22.1849 5.48548 22.9628 4.51624 23.3373 3.36466C22.3866 3.93086 21.3301 4.33391 20.2065 4.55463C19.3037 3.59498 18.0264 3 16.6146 3C13.8968 3 11.6879 5.20718 11.6879 7.92298C11.6879 8.30684 11.7359 8.6811 11.8127 9.04577C7.72149 8.84424 4.09124 6.87697 1.66146 3.90207C1.2389 4.6314 0.9988 5.47589 0.9988 6.37795C0.9988 8.08612 1.87275 9.59277 3.18848 10.4756C2.38175 10.4468 1.62305 10.2261 0.960384 9.86146C0.960384 9.88066 0.960384 9.89985 0.960384 9.92864C0.960384 12.3086 2.66026 14.3046 4.90756 14.7557C4.4946 14.8708 4.06242 14.9284 3.61104 14.9284C3.29412 14.9284 2.98679 14.8996 2.68908 14.842C3.31333 16.7997 5.13806 18.22 7.28932 18.2584C5.59904 19.5827 3.47659 20.3696 1.17167 20.3696C0.777912 20.3696 0.384154 20.3504 0 20.3024C2.17047 21.6843 4.76351 22.5 7.53902 22.5Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c0bd7b1c70d70d649ea5c0fe4031ed16.svg";
export { ForwardRef as ReactComponent };